class CustomModal extends HTMLElement {
  static get template() {
    // 第一次创建, 后续访问已创建好的template
    if (!this._template) {
      this._template = document.createElement('template');
      this._template.innerHTML = `
        <div class="custom-modal-container">
          <div class="custom-modal-mask">
            <slot></slot>
          </div>
        </div>
      `;
    }
    return this._template;
  }

  constructor() {
    super();
    
    this.appendChild(CustomModal.template.content.cloneNode(true));
    this.moveToBody();
    this.replaceSlotWithUserContent();
    this.bindEvents();
  }

  // 移动到body
  moveToBody() {
    if (this.parentNode && this.parentNode !== document.body) {
      document.body.appendChild(this);
    }
  }
  
  replaceSlotWithUserContent() {
    const slotElement = this.querySelector('slot');

    // 获取模板容器（要排除的节点）
    const templateContainer = this.querySelector('.custom-modal-container');

    // 获取用户传入的内容（排除模板容器）
    const userContent = Array.from(this.childNodes).filter(node => node !== templateContainer);

    // 用户内容替换slot
    slotElement.replaceWith(...userContent);
  }
  
  bindEvents() {
    const mask = this.querySelector('.custom-modal-mask');
    
    mask.addEventListener('click', (event) => {
      // 只有点击的是mask本身才关闭弹窗，避免点击用户内容时关闭
      if (event.target === mask) {
        this.close();
      }
    });
  }
  
  open() {
    this.style.setProperty('display', 'block');
    document.body.style.setProperty('overflow', 'hidden');
  }
  
  close() {
    this.style.removeProperty('display');
    document.body.style.removeProperty('overflow');
  }
}

customElements.define('custom-modal', CustomModal);
